import axios from '@/axios.js';

export default {
  methods: {
    configureListLayout() {
      const defaultConfig = {
        card1: { size: 'small' },
        card2: { size: 'small' },
        card3: { size: 'small' },
        card4: { size: 'large' },
        card5: { size: 'large' },
        card6: { size: 'small' },
        card7: { size: 'medium' },
        card8: { size: 'medium' },
        card9: { size: 'small' },
      };

      Object.keys(this.site_setting.platforms).forEach(cardKey => {
        const card = this.site_setting.platforms[cardKey];
        if (card) {
          const cardNumber = parseInt(cardKey.replace('card', ''));
          if (cardNumber <= 9) {
            card.size = defaultConfig[cardKey].size;
          }
        }
      });
    },

    configureGridLayout() {
      const defaultConfig = {
        card1: { position: 'left', size: 'medium' },
        card2: { position: 'left', size: 'medium' },
        card3: { position: 'left', size: 'large' },
        card4: { position: 'left', size: 'medium' },
        card5: { position: 'right', size: 'large' },
        card6: { position: 'right', size: 'small' },
        card7: { position: 'right', size: 'medium' },
        card8: { position: 'right', size: 'medium' },
        card9: { position: 'right', size: 'small' },
      };

      Object.keys(this.site_setting.platforms).forEach(cardKey => {
        const card = this.site_setting.platforms[cardKey];
        if (card) {
          const cardNumber = parseInt(cardKey.replace('card', ''));

          if (!card.position) {
            if (cardNumber <= 9 && defaultConfig[cardKey]) {
              card.position = defaultConfig[cardKey].position;
            }
          }

          if (!card.size) {
            if (cardNumber <= 9 && defaultConfig[cardKey]) {
              card.size = defaultConfig[cardKey].size;
            }
          }
        }
      });
    },

    async changeSiteLayout(newLayout) {
      try {
        const layoutMap = {
          'grid': 1,
          'list': 2
        };

        const layoutId = layoutMap[newLayout];

        if (newLayout === 'list') {
          this.configureListLayout();
        } else if (newLayout === 'grid') {
          this.configureGridLayout();
        }

        await axios.post('/change-layout', {
          site_id: this.harmony.id,
          layout_id: layoutId
        });

        this.selectedLayout = newLayout;
        this.harmony.site_settings.layout.name = newLayout;

        await this.saveSettings();

        this.$vs.notify({
          title: this.$t('harmony.layouts.layout-changed-title'),
          text: this.$t('harmony.layouts.layout-changed-text'),
          color: 'success',
          icon: 'check_box',
          position: 'bottom-center',
          time: 5000,
        });

      } catch (error) {
        console.error('Error changing layout:', error);

        this.$vs.notify({
          title: this.$t('harmony.layouts.layout-error-title'),
          text: this.$t('harmony.layouts.layout-error-text'),
          color: 'danger',
          icon: 'warning',
          position: 'bottom-center',
          time: 5000,
        });
      }
    }
  }
}
